<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  question: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  };
  selected: string[];
}>();
</script>

<template>
  <div class="tpl-zpl__question">
    <div class="tpl-zpl__bubble tpl-zpl__bubble--bot">{{ question.title }}</div>
    <div class="tpl-zpl__answers">
      <button
        v-for="answer in question.answers"
        :key="answer[0]"
        type="button"
        class="tpl-zpl__answer"
        @click="$emit('answer', answer)"
      >
        {{ String(answer[1]) }}
      </button>
    </div>
  </div>
</template>
